import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    return stored ? JSON.parse(stored) : null;
  });

  const login = (credentials, tipo) => {
    // tipo = 'admin' ou 'cliente'
    // credentials vem do backend, por exemplo: { id, nome, token }

    const userData = { ...credentials, tipo };
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));

    if (tipo === "admin") navigate("/dashboard");
    else navigate("/home");
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
